import "./platform/archiveRuntime.js";
import "./platform/initialize.js";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { ArchiveRouter } from "./routing/ArchiveRouter.jsx";
import { App } from "./recovered/Application.jsx";
import "./styles/docs.css";
import "./styles/main.css";
import "./styles/aiNews.css";
import "./styles/fonts.css";
import "./styles/preflight.css";
import "./styles/custom.css";
const root = document.getElementById("root");
if (!root) throw new Error("The application root is missing.");
if (window.location.hash.startsWith("#/")) {
  window.history.replaceState(null, "", window.location.hash.slice(1));
}
createRoot(root).render(
  <React.StrictMode>
    <ArchiveRouter basename="">
      <App />
    </ArchiveRouter>
  </React.StrictMode>,
);
document.documentElement.dataset.mimoHydrated = "1";
